<div class="t4Translation" (mouseenter)="toggleEditButton(true)" (mouseleave)="toggleEditButton(false)">

    <div (focusout)="edit(false)" spellcheck="false" *ngIf="!isEditing">{{ key | translate : defaultValue }}</div>
    <input #input class="input" [(ngModel)]="displayText" *ngIf="isEditing" (focusout)="edit(false)" [size]="displayText.length" (keydown)="edit(false, $event)" />

    <div class="edit" *ngIf="displayEditbutton && !isEditing" [class.focus]="isEditing" style="background: rgba(255, 255, 255, 0)" (click)="edit(true)">
        <mat-icon style="font-size: 18px">edit</mat-icon>
    </div>

</div>